export const User2FAState = {
  UNSET: 0,
  CREATED: 1,
  AUTHENTICATED: 2,
  RECOVERY_CHECKED: 3,
  ENABLED: 4,
  DISABLED: 5,
}
